// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_COMMENT = "pridanie odpovede";
